import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import { Participants as ParticipantsTrans } from 'autogen/translation-keys/trans-website-liveevent';
import { BorderRadiusMedium, ColorNeutralWhite, Spacing8 } from 'autogen/design-tokens/tokens';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';
import type { ArticleHeaderFromContextProps } from '../shared/types';
import LinkAction from 'components/shared/Routing/components/LinkAction/LinkAction';

// #region Styles
const Wrapper = styled.nav``;

const List = styled.ul`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
`;

const ListItem = styled.li`
    display: inline-flex;
    margin-bottom: ${Spacing8};
    margin-right: ${Spacing8};
`;

const Participant = styled(LinkAction)`
    display: flex;
    align-items: center;
    padding: ${Spacing8};
    border-radius: ${BorderRadiusMedium};
    background-color: rgb(from ${ColorNeutralWhite} r g b / 40%);
`;

const StyledPicture = styled(PictureDeprecated)`
    .cms-article & .img, // cms overwrite
    img {
        width: 24px;
        height: 24px;
        border-radius: 100%;
        margin-right: ${Spacing8};
        border: 1px solid ${ColorNeutralWhite};
    }
`;

const Headline = styled(Typography.Body)`
    margin-bottom: ${Spacing8};
`;

// #endregion Styles

export default function Participants({
    paticipants,
    ...restProps
}: {
    paticipants: Exclude<ArticleHeaderFromContextProps['participants'], undefined>;
}) {
    const { t } = useTranslation();

    return (
        <Wrapper {...restProps}>
            <Headline forwardedAs="div" size="M" strong>
                {t(ParticipantsTrans)}
            </Headline>
            <List>
                {paticipants.map((participant, index) => {
                    const { link, name, image } = participant;
                    const linkProps = link ? { action: link.linkAction, ...link } : {}; // todo niels could be a maybe?

                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <ListItem key={index}>
                            <Participant
                                action={link.linkAction}
                                target={link.target}
                                title={link.title}
                                {...linkProps}
                            >
                                {image && <StyledPicture {...image} lazyLoad />}
                                <Typography.Body forwardedAs="div" size="S" strong>
                                    {name}
                                </Typography.Body>
                            </Participant>
                        </ListItem>
                    );
                })}
            </List>
        </Wrapper>
    );
}
